import { Link } from 'react-router-dom'
import { ShipmentStatusBadge } from '@/components/ShipmentStatusBadge'
import { formatDate } from '@/lib/format'
import { formatCustomerNumber } from '@/lib/customer'
import { formatShipmentNumber, hasShipmentLabel } from '@/lib/shipment'
import type { ShipmentWithCustomer } from '@/api/types'

interface ShipmentTableRowProps {
  shipment: ShipmentWithCustomer
  isSelected: boolean
  onToggleSelected: (shipmentId: number) => void
}

export function ShipmentTableRow({ shipment, isSelected, onToggleSelected }: ShipmentTableRowProps): React.ReactElement {
  const canSelect = hasShipmentLabel(shipment)

  return (
    <tr className="border-t border-border/70">
      <td className="px-6 py-4">
        <input
          type="checkbox"
          aria-label={`Markera leverans ${shipment.id}`}
          className="size-4 align-middle accent-primary"
          checked={isSelected}
          disabled={!canSelect}
          onChange={() => onToggleSelected(shipment.id)}
        />
      </td>
      <td className="px-6 py-4 font-medium">
        <Link
          to={`/shipments/${shipment.id}`}
          className="hover:underline"
        >
          {shipment.customer_name ?? 'Okänd kund'}
        </Link>
        <span className="mt-1 block text-xs font-normal text-muted-foreground">
          {formatCustomerNumber(shipment.customer_id)} · {formatShipmentNumber(shipment.id)}
        </span>
      </td>
      <td className="px-6 py-4 text-muted-foreground">#{shipment.sequence}</td>
      <td className="px-6 py-4">
        <ShipmentStatusBadge status={shipment.status} />
      </td>
      <td className="px-6 py-4 text-muted-foreground">{shipment.postnord_shipment_id ?? '–'}</td>
      <td className="px-6 py-4 text-muted-foreground">{formatDate(shipment.created_at)}</td>
    </tr>
  )
}
